


















































































import { Vue, Component, Prop } from "vue-property-decorator";
import { NoteList, Note } from "../models/note.model";
import { noteService } from "../services/note.service";

import TextInput from "@/components/TextInput.vue";
import Modal from "./Modal.vue";

@Component({
    components: {
        TextInput,
        Modal,
    },
})
export default class NoteListComponent extends Vue {
    @Prop() private noteList!: NoteList;

    noteListObject: NoteList = this.noteList;
    newNote: Note = { noteListId: this.noteList.id, text: "" };
    editNoteId: number = 0;
    editNoteList: boolean = false;

    mounted() {
        this.noteListObject.notes = !this.noteList.notes
            ? []
            : this.noteList.notes;
    }

    async deleteNote(id: number) {
        if (
            //@ts-ignore
            await this.$refs.confirmModal.open(
                "Vill du ta bort anteckningen?"
            )
        ) {
            var result = await noteService.deleteNote(id);
            if (result) {
                var index = this.noteListObject.notes!.findIndex(
                    (n: Note) => n.id == id
                );
                this.noteListObject.notes!.splice(index, 1);
            }
        }
    }

    async createNote(note: Note) {
        var result = await noteService.createNote(note);
        if (result) {
            this.noteListObject.notes!.push(({
                id: result,
                text: this.newNote.text,
                noteListId: this.newNote.noteListId,
            } as unknown) as Note);
            this.newNote.text = "";
        }
    }

    async updateNote(note: Note) {
        var result = await noteService.updateNote(note);
        if (result) {
            this.editNoteId = 0;
        }
    }

    async updateNoteList(noteList: NoteList) {
        var result = await noteService.updateNoteList(noteList);
        if (result) {
            this.editNoteList = false;
        }
    }
}
